export interface MarketplaceMetrics {
    listingViews: number;
    inquiriesReceived: number;
    responsesGiven: number;
}

interface SummaryCardProps {
    metrics: MarketplaceMetrics;
    onViewReport?: () => void;
}

const SummaryCard = ({ metrics, onViewReport }: SummaryCardProps) => {
    return (
        <div className="card rounded-3 overflow-hidden h-100 border-0 shadow-sm">
            <div className="card-header bg-white p-4 border-0">
                <h6 className="font-18 mb-0 font-600 text-center">SUMMARY</h6>
            </div>

            <div className="card-body d-flex flex-column justify-content-center align-items-center">
                <div className="d-flex justify-content-center align-items-start mb-2">
                    Listing Views: <span className="font-500 ms-2">{metrics.listingViews}</span>
                </div>
                <div className="d-flex justify-content-center align-items-start mb-2">
                    Inquiries Received: <span className="font-500 ms-2">{metrics.inquiriesReceived}</span>
                </div>
                <div className="d-flex justify-content-center align-items-start">
                    Responded by You: <span className="font-500 ms-2">{metrics.responsesGiven}</span>
                </div>
            </div>

            <div className="d-flex justify-content-center px-3 py-3 lite-blue">
                <button
                    type="button"
                    className="btn-skyblue btn-sm rounded-pill px-3 font-14 font-400"
                    onClick={onViewReport}>
                    View Report
                </button>
            </div>
        </div>
    );
};

export default SummaryCard;